/**
 * Tracks a referral/signup event with FirstPromoter.
 * Call this after a successful user registration to attribute the signup to a promoter.
 * Safe to call even if fpr.js is blocked by ad blockers or not loaded.
 */
export function fprReferral(email: string, uid: string): void {
  try {
    if (typeof window !== 'undefined' && (window as any).fpr) {
      ;(window as any).fpr('referral', { email, uid })
    }
  } catch (error) {
    console.warn('Failed to track FirstPromoter referral:', error)
  }
}
